const ProductVersion = () => (
  <div className="ProductVersion">
    CHS Direct V2 <br />
    Release: 4
  </div>
);

export default ProductVersion;
